import { useState as i, useMemo as e, useCallback as t, createElement as o, Fragment as n } from "react";
import { useTheme as r, useMotionConfig as a, useAnimatedPath as d, Container as c, useDimensions as l, SvgWrapper as s, ResponsiveWrapper as v, bindDefs as u } from "@nivo/core";
import { Grid as p, Axes as h } from "@nivo/axes";
import { line as f, curveBasis as g, curveLinear as y, area as m } from "d3-shape";
import { useOrdinalColorScale as b, useInheritedColor as x } from "@nivo/colors";
import { useTooltip as W, BasicTooltip as O } from "@nivo/tooltip";
import { scalePoint as P, scaleLinear as S } from "d3-scale";
import { castPointScale as L, castLinearScale as M } from "@nivo/scales";
import { jsx as I, jsxs as C, Fragment as B } from "react/jsx-runtime";
import { useSpring as k, animated as A, to as E, useSprings as w } from "@react-spring/web";

function z() {
  return z = Object.assign || function (i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
      }
    }

    return i;
  }, z.apply(this, arguments);
}

function T(i, e) {
  if (null == i) return {};
  var t,
      o,
      n = {},
      r = Object.keys(i);

  for (o = 0; o < r.length; o++) {
    t = r[o], e.indexOf(t) >= 0 || (n[t] = i[t]);
  }

  return n;
}

var G = function G(i) {
  return e(function () {
    return "function" == typeof i ? i : function () {
      return i;
    };
  }, [i]);
},
    F = function F(o) {
  var n = o.width,
      a = o.height,
      d = o.data,
      c = o.interpolation,
      l = o.xPadding,
      s = o.xOuterPadding,
      v = o.yOuterPadding,
      u = o.lineWidth,
      p = o.activeLineWidth,
      h = o.inactiveLineWidth,
      m = o.colors,
      W = o.opacity,
      O = o.activeOpacity,
      S = o.inactiveOpacity,
      M = o.pointSize,
      I = o.activePointSize,
      C = o.inactivePointSize,
      B = o.pointColor,
      k = o.pointBorderWidth,
      A = o.activePointBorderWidth,
      E = o.inactivePointBorderWidth,
      w = o.pointBorderColor,
      T = o.isInteractive,
      F = o.defaultActiveSerieIds,
      H = i(F),
      X = H[0],
      j = H[1],
      Y = e(function () {
    return function (i) {
      var e = i.width,
          t = i.height,
          o = i.data,
          n = i.xPadding,
          r = i.xOuterPadding,
          a = i.yOuterPadding,
          d = new Set(),
          c = new Set();
      o.forEach(function (i) {
        i.data.forEach(function (i) {
          d.add(i.x), null !== i.y && c.add(i.y);
        });
      });
      var l = Array.from(d),
          s = L(P().domain(l).range([0, e]).padding(r)),
          v = Array.from(c).sort(function (i, e) {
        return i - e;
      }),
          u = L(P().domain(v).range([0, t]).padding(a)),
          p = s.step() * Math.min(.5 * n, .5);
      return {
        series: o.map(function (i) {
          var t = {
            id: i.id,
            data: i,
            points: [],
            linePoints: []
          };
          return i.data.forEach(function (o, n) {
            var r = null,
                a = null;
            null !== o.y && (r = s(o.x), a = u(o.y));
            var d = {
              id: i.id + "." + n,
              serie: i,
              data: o,
              x: r,
              y: a
            };
            t.points.push(d), null !== d.x && (0 === n ? t.linePoints.push([0, d.y]) : t.linePoints.push([d.x - p, d.y])), t.linePoints.push([d.x, d.y]), null !== r && (n === i.data.length - 1 && r ? t.linePoints.push([e, d.y]) : t.linePoints.push([d.x + p, d.y])), t.points = t.points.filter(function (i) {
              return null !== i.x;
            });
          }), t;
        }),
        xScale: s,
        yScale: u
      };
    }({
      width: n,
      height: a,
      data: d,
      xPadding: l,
      xOuterPadding: s,
      yOuterPadding: v
    });
  }, [n, a, d, l, s, v]),
      K = Y.series,
      R = Y.xScale,
      q = Y.yScale,
      D = function (i) {
    return e(function () {
      return f().curve("smooth" === i ? g : y).defined(function (i) {
        return null !== i[0] && null !== i[1];
      });
    }, [i]);
  }(c),
      J = b(m, "id"),
      N = function (i) {
    var e = i.lineWidth,
        o = i.activeLineWidth,
        n = i.inactiveLineWidth,
        r = i.opacity,
        a = i.activeOpacity,
        d = i.inactiveOpacity,
        c = i.isInteractive,
        l = i.activeSerieIds,
        s = G(e),
        v = G(o),
        u = G(n),
        p = G(r),
        h = G(a),
        f = G(d),
        g = t(function (i) {
      return {
        opacity: p(i),
        lineWidth: s(i)
      };
    }, [s, p]),
        y = t(function (i) {
      return {
        opacity: h(i),
        lineWidth: v(i)
      };
    }, [v, h]),
        m = t(function (i) {
      return {
        opacity: f(i),
        lineWidth: u(i)
      };
    }, [u, f]);
    return t(function (i) {
      return c && 0 !== l.length ? l.includes(i.id) ? y(i) : m(i) : g(i);
    }, [g, y, m, c, l]);
  }({
    lineWidth: u,
    activeLineWidth: p,
    inactiveLineWidth: h,
    opacity: W,
    activeOpacity: O,
    inactiveOpacity: S,
    isInteractive: T,
    activeSerieIds: X
  }),
      Q = e(function () {
    return K.map(function (i) {
      return z({}, i, {
        color: J(i.data)
      }, N(i));
    });
  }, [K, J, N]),
      U = r(),
      V = x(B, U),
      Z = x(w, U),
      $ = function (i) {
    var e = i.pointSize,
        o = i.activePointSize,
        n = i.inactivePointSize,
        r = i.pointBorderWidth,
        a = i.activePointBorderWidth,
        d = i.inactivePointBorderWidth,
        c = i.isInteractive,
        l = i.activeSerieIds,
        s = G(e),
        v = G(o),
        u = G(n),
        p = G(r),
        h = G(a),
        f = G(d),
        g = t(function (i) {
      return {
        size: s(i),
        borderWidth: p(i)
      };
    }, [s, p]),
        y = t(function (i) {
      return {
        size: v(i),
        borderWidth: h(i)
      };
    }, [v, h]),
        m = t(function (i) {
      return {
        size: u(i),
        borderWidth: f(i)
      };
    }, [u, f]);
    return t(function (i) {
      return c && 0 !== l.length ? l.includes(i.serie.id) ? y(i) : m(i) : g(i);
    }, [g, y, m, c, l]);
  }({
    pointSize: M,
    activePointSize: I,
    inactivePointSize: C,
    pointBorderWidth: k,
    activePointBorderWidth: A,
    inactivePointBorderWidth: E,
    isInteractive: T,
    activeSerieIds: X
  }),
      _ = e(function () {
    var i = [];
    return Q.forEach(function (e) {
      e.points.forEach(function (t) {
        var o = z({}, t, {
          serie: e,
          isActive: X.includes(e.id),
          isInactive: X.length > 0 && !X.includes(e.id)
        });
        o.color = V(o), o.borderColor = Z(o), i.push(z({}, o, $(o)));
      });
    }), i;
  }, [Q, V, Z, $, X]);

  return {
    xScale: R,
    yScale: q,
    series: Q,
    points: _,
    lineGenerator: D,
    activeSerieIds: X,
    setActiveSerieIds: j
  };
},
    H = function H(i) {
  var n = i.serie,
      r = i.isInteractive,
      a = i.onMouseEnter,
      d = i.onMouseMove,
      c = i.onMouseLeave,
      l = i.onClick,
      s = i.setActiveSerieIds,
      v = i.tooltip,
      u = W(),
      p = u.showTooltipFromEvent,
      h = u.hideTooltip,
      f = t(function (i) {
    p(o(v, {
      serie: n
    }), i), s([n.id]), a && a(n, i);
  }, [n, a, p, s, v]),
      g = t(function (i) {
    p(o(v, {
      serie: n
    }), i), d && d(n, i);
  }, [n, d, p, v]),
      y = t(function (i) {
    h(), s([]), c && c(n, i);
  }, [n, c, h, s]),
      m = t(function (i) {
    l && l(n, i);
  }, [n, l]);
  return e(function () {
    return {
      onMouseEnter: r ? f : void 0,
      onMouseMove: r ? g : void 0,
      onMouseLeave: r ? y : void 0,
      onClick: r ? m : void 0
    };
  }, [r, f, g, y, m]);
},
    X = function X(i) {
  var t = i.series,
      o = i.position,
      n = i.padding,
      a = i.color,
      d = i.getLabel,
      c = r(),
      l = x(a, c);
  return e(function () {
    var i, e;
    "start" === o ? (i = "end", e = -1 * n) : (i = "start", e = n);
    var r = [];
    return t.forEach(function (t) {
      var n = t.id;
      "function" == typeof d && (n = d(t.data));
      var a = "start" === o ? t.linePoints[0] : t.linePoints[t.linePoints.length - 1];
      null !== a[0] && null !== a[1] && r.push({
        id: t.id,
        label: n,
        x: a[0] + e,
        y: a[1],
        color: l(t),
        opacity: t.opacity,
        serie: t,
        textAnchor: i
      });
    }), r;
  }, [t, o, n, l, d]);
},
    j = {
  pointerEvents: "none"
},
    Y = z({}, {
  layers: ["grid", "axes", "labels", "lines", "points"],
  interpolation: "smooth",
  xPadding: .6,
  xOuterPadding: .5,
  yOuterPadding: .5,
  colors: {
    scheme: "nivo"
  },
  lineWidth: 2,
  activeLineWidth: 4,
  inactiveLineWidth: 1,
  opacity: 1,
  activeOpacity: 1,
  inactiveOpacity: .3,
  startLabel: !1,
  startLabelPadding: 16,
  startLabelTextColor: {
    from: "color"
  },
  endLabel: !0,
  endLabelPadding: 16,
  endLabelTextColor: {
    from: "color"
  },
  pointSize: 6,
  activePointSize: 8,
  inactivePointSize: 4,
  pointColor: {
    from: "serie.color"
  },
  pointBorderWidth: 0,
  activePointBorderWidth: 0,
  inactivePointBorderWidth: 0,
  pointBorderColor: {
    from: "serie.color",
    modifiers: [["darker", 1.4]]
  },
  enableGridX: !0,
  enableGridY: !0,
  axisTop: {},
  axisBottom: {},
  axisLeft: {},
  isInteractive: !0,
  defaultActiveSerieIds: [],
  tooltip: function tooltip(i) {
    var e = i.serie;
    return I(O, {
      "data-testid": "tooltip." + e.data.id,
      id: e.data.id,
      enableChip: !0,
      color: e.color
    });
  },
  role: "img"
}, {
  pointComponent: function pointComponent(i) {
    var e = i.point,
        t = a(),
        o = t.animate,
        n = t.config,
        r = k({
      x: e.x,
      y: e.y,
      radius: e.size / 2,
      color: e.color,
      borderWidth: e.borderWidth,
      config: n,
      immediate: !o
    });
    return I(A.circle, {
      "data-testid": "point." + e.serie.id + "." + e.data.x,
      cx: r.x,
      cy: r.y,
      r: E(r.radius, function (i) {
        return Math.max(i, 0);
      }),
      fill: r.color,
      strokeWidth: r.borderWidth,
      stroke: e.borderColor,
      style: j
    });
  },
  animate: !0,
  motionConfig: "gentle"
}),
    K = function K(i) {
  var e = i.serie,
      t = i.lineGenerator,
      o = i.yStep,
      n = i.isInteractive,
      r = i.onMouseEnter,
      c = i.onMouseMove,
      l = i.onMouseLeave,
      s = i.onClick,
      v = i.setActiveSerieIds,
      u = i.tooltip,
      p = H({
    serie: e,
    isInteractive: n,
    onMouseEnter: r,
    onMouseMove: c,
    onMouseLeave: l,
    onClick: s,
    setActiveSerieIds: v,
    tooltip: u
  }),
      h = a(),
      f = h.animate,
      g = h.config,
      y = t(e.linePoints) || "",
      m = d(y),
      b = k({
    color: e.color,
    opacity: e.opacity,
    lineWidth: e.lineWidth,
    config: g,
    immediate: !f
  });
  return C(B, {
    children: [I(A.path, {
      "data-testid": "line." + e.id,
      fill: "none",
      d: m,
      stroke: b.color,
      strokeWidth: b.lineWidth,
      strokeLinecap: "round",
      strokeOpacity: b.opacity,
      style: {
        pointerEvents: "none"
      }
    }), n && I("path", {
      "data-testid": "line." + e.id + ".interactive",
      fill: "none",
      stroke: "red",
      strokeOpacity: 0,
      strokeWidth: o,
      d: y,
      strokeLinecap: "butt",
      onMouseEnter: p.onMouseEnter,
      onMouseMove: p.onMouseMove,
      onMouseLeave: p.onMouseLeave,
      onClick: p.onClick
    })]
  });
},
    R = function R(i) {
  var e = i.series,
      t = i.getLabel,
      o = i.position,
      n = i.padding,
      d = i.color,
      c = r(),
      l = a(),
      s = l.animate,
      v = l.config,
      u = X({
    series: e,
    getLabel: t,
    position: o,
    padding: n,
    color: d
  }),
      p = w(u.length, u.map(function (i) {
    return {
      x: i.x,
      y: i.y,
      opacity: i.opacity,
      config: v,
      immediate: !s
    };
  }));
  return I(B, {
    children: p.map(function (i, e) {
      var t = u[e];
      return I(A.text, {
        "data-testid": "label." + o + "." + t.serie.id,
        x: i.x,
        y: i.y,
        textAnchor: t.textAnchor,
        dominantBaseline: "central",
        opacity: i.opacity,
        style: z({}, c.labels.text, {
          fill: t.color
        }),
        children: t.label
      }, t.id);
    })
  });
},
    q = function q(i) {
  var e = i.points,
      t = i.pointComponent;
  return I(B, {
    children: e.map(function (i) {
      return o(t, {
        key: i.id,
        point: i
      });
    })
  });
},
    D = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
    J = function J(i) {
  var t = i.data,
      r = i.width,
      a = i.height,
      d = i.margin,
      c = i.layers,
      v = void 0 === c ? Y.layers : c,
      u = i.interpolation,
      f = void 0 === u ? Y.interpolation : u,
      g = i.xPadding,
      y = void 0 === g ? Y.xPadding : g,
      m = i.xOuterPadding,
      b = void 0 === m ? Y.xOuterPadding : m,
      x = i.yOuterPadding,
      W = void 0 === x ? Y.yOuterPadding : x,
      O = i.colors,
      P = void 0 === O ? Y.colors : O,
      S = i.lineWidth,
      L = void 0 === S ? Y.lineWidth : S,
      M = i.activeLineWidth,
      B = void 0 === M ? Y.activeLineWidth : M,
      k = i.inactiveLineWidth,
      A = void 0 === k ? Y.inactiveLineWidth : k,
      E = i.opacity,
      w = void 0 === E ? Y.opacity : E,
      z = i.activeOpacity,
      T = void 0 === z ? Y.activeOpacity : z,
      G = i.inactiveOpacity,
      H = void 0 === G ? Y.inactiveOpacity : G,
      X = i.startLabel,
      j = void 0 === X ? Y.startLabel : X,
      D = i.startLabelPadding,
      J = void 0 === D ? Y.startLabelPadding : D,
      N = i.startLabelTextColor,
      Q = void 0 === N ? Y.startLabelTextColor : N,
      U = i.endLabel,
      V = void 0 === U ? Y.endLabel : U,
      Z = i.endLabelPadding,
      $ = void 0 === Z ? Y.endLabelPadding : Z,
      _ = i.endLabelTextColor,
      ii = void 0 === _ ? Y.endLabelTextColor : _,
      ei = i.pointComponent,
      ti = void 0 === ei ? Y.pointComponent : ei,
      oi = i.pointSize,
      ni = void 0 === oi ? Y.pointSize : oi,
      ri = i.activePointSize,
      ai = void 0 === ri ? Y.activePointSize : ri,
      di = i.inactivePointSize,
      ci = void 0 === di ? Y.inactivePointSize : di,
      li = i.pointColor,
      si = void 0 === li ? Y.pointColor : li,
      vi = i.pointBorderWidth,
      ui = void 0 === vi ? Y.pointBorderWidth : vi,
      pi = i.activePointBorderWidth,
      hi = void 0 === pi ? Y.activePointBorderWidth : pi,
      fi = i.inactivePointBorderWidth,
      gi = void 0 === fi ? Y.inactivePointBorderWidth : fi,
      yi = i.pointBorderColor,
      mi = void 0 === yi ? Y.pointBorderColor : yi,
      bi = i.enableGridX,
      xi = void 0 === bi ? Y.enableGridX : bi,
      Wi = i.enableGridY,
      Oi = void 0 === Wi ? Y.enableGridY : Wi,
      Pi = i.axisTop,
      Si = void 0 === Pi ? Y.axisTop : Pi,
      Li = i.axisRight,
      Mi = i.axisBottom,
      Ii = void 0 === Mi ? Y.axisBottom : Mi,
      Ci = i.axisLeft,
      Bi = void 0 === Ci ? Y.axisLeft : Ci,
      ki = i.isInteractive,
      Ai = void 0 === ki ? Y.isInteractive : ki,
      Ei = i.defaultActiveSerieIds,
      wi = void 0 === Ei ? Y.defaultActiveSerieIds : Ei,
      zi = i.onMouseEnter,
      Ti = i.onMouseMove,
      Gi = i.onMouseLeave,
      Fi = i.onClick,
      Hi = i.tooltip,
      Xi = void 0 === Hi ? Y.tooltip : Hi,
      ji = i.role,
      Yi = void 0 === ji ? Y.role : ji,
      Ki = l(r, a, d),
      Ri = Ki.margin,
      qi = Ki.innerWidth,
      Di = Ki.innerHeight,
      Ji = Ki.outerWidth,
      Ni = Ki.outerHeight,
      Qi = F({
    width: qi,
    height: Di,
    data: t,
    interpolation: f,
    xPadding: y,
    xOuterPadding: b,
    yOuterPadding: W,
    lineWidth: L,
    activeLineWidth: B,
    inactiveLineWidth: A,
    colors: P,
    opacity: w,
    activeOpacity: T,
    inactiveOpacity: H,
    pointSize: ni,
    activePointSize: ai,
    inactivePointSize: ci,
    pointColor: si,
    pointBorderWidth: ui,
    activePointBorderWidth: hi,
    inactivePointBorderWidth: gi,
    pointBorderColor: mi,
    isInteractive: Ai,
    defaultActiveSerieIds: wi
  }),
      Ui = Qi.series,
      Vi = Qi.points,
      Zi = Qi.xScale,
      $i = Qi.yScale,
      _i = Qi.lineGenerator,
      ie = Qi.activeSerieIds,
      ee = Qi.setActiveSerieIds,
      te = {
    grid: null,
    axes: null,
    labels: null,
    lines: null,
    points: null
  };
  v.includes("grid") && (te.grid = I(p, {
    width: qi,
    height: Di,
    xScale: xi ? Zi : null,
    yScale: Oi ? $i : null
  }, "grid")), v.includes("axes") && (te.axes = I(h, {
    xScale: Zi,
    yScale: $i,
    width: qi,
    height: Di,
    top: Si,
    right: Li,
    bottom: Ii,
    left: Bi
  }, "axes")), v.includes("lines") && (te.lines = I(n, {
    children: Ui.map(function (i) {
      return I(K, {
        serie: i,
        setActiveSerieIds: ee,
        lineGenerator: _i,
        yStep: $i.step(),
        isInteractive: Ai,
        onMouseEnter: zi,
        onMouseMove: Ti,
        onMouseLeave: Gi,
        onClick: Fi,
        tooltip: Xi
      }, i.id);
    })
  }, "lines")), v.includes("points") && (te.points = I(q, {
    pointComponent: ti,
    points: Vi
  }, "points")), v.includes("labels") && (te.labels = C(n, {
    children: [!1 !== j && I(R, {
      series: Ui,
      getLabel: j,
      position: "start",
      padding: J,
      color: Q
    }), !1 !== V && I(R, {
      series: Ui,
      getLabel: V,
      position: "end",
      padding: $,
      color: ii
    })]
  }, "legends"));
  var oe = e(function () {
    return {
      innerHeight: Di,
      innerWidth: qi,
      lineGenerator: _i,
      points: Vi,
      series: Ui,
      xScale: Zi,
      yScale: $i,
      activeSerieIds: ie,
      setActiveSerieIds: ee
    };
  }, [ie, ee, Di, qi, _i, Vi, Ui, Zi, $i]);
  return I(s, {
    width: Ji,
    height: Ni,
    margin: Ri,
    role: Yi,
    children: v.map(function (i, e) {
      var t;
      return "function" == typeof i ? I(n, {
        children: o(i, oe)
      }, e) : null != (t = null == te ? void 0 : te[i]) ? t : null;
    })
  });
},
    N = function N(i) {
  var e = i.isInteractive,
      t = void 0 === e ? Y.isInteractive : e,
      o = i.animate,
      n = void 0 === o ? Y.animate : o,
      r = i.motionConfig,
      a = void 0 === r ? Y.motionConfig : r,
      d = i.theme,
      l = i.renderWrapper,
      s = T(i, D);
  return I(c, {
    animate: n,
    isInteractive: t,
    motionConfig: a,
    renderWrapper: l,
    theme: d,
    children: I(J, z({
      isInteractive: t
    }, s))
  });
},
    Q = function Q(i) {
  return I(v, {
    children: function children(e) {
      var t = e.width,
          o = e.height;
      return I(N, z({
        width: t,
        height: o
      }, i));
    }
  });
},
    U = function U(i) {
  var t = i.data,
      o = i.width,
      n = i.height,
      r = i.align,
      a = i.spacing,
      d = i.xPadding;
  return e(function () {
    return function (i) {
      var e,
          t,
          o = i.data,
          n = i.width,
          r = i.height,
          a = i.align,
          d = i.spacing,
          c = i.xPadding,
          l = new Map();
      o.forEach(function (i) {
        i.data.forEach(function (o) {
          l.has(o.x) || l.set(o.x, {
            id: o.x,
            total: 0,
            values: new Map(),
            x: 0
          });
          var n = l.get(o.x),
              r = n.total + o.y;
          n.total = r, n.values.set(i.id, {
            serieId: i.id,
            value: o.y,
            position: 0,
            height: 0,
            beforeHeight: 0
          }), (void 0 === e || r > e) && (e = r), (void 0 === t || n.values.size > t) && (t = n.values.size);
        });
      });
      var s = L(P().domain(Array.from(l.keys())).range([0, n])),
          v = M(S().domain([0, e]).range([0, r - t * d]));
      l.forEach(function (i, e) {
        i.x = s(e);
        var t = v(i.total) + i.values.size * d,
            o = 0;
        "middle" === a ? o = (r - t) / 2 : "end" === a && (o = r - t), Array.from(i.values.values()).sort(function (i, e) {
          return e.value - i.value;
        }).forEach(function (e, t, n) {
          var r = n.filter(function (i, e) {
            return e < t;
          }),
              a = r.reduce(function (i, e) {
            return i + e.value;
          }, 0),
              c = i.values.get(e.serieId);
          c.position = t, c.height = v(e.value), c.beforeHeight = v(a) + o + d * (r.length + .5);
        });
      });
      var u = s.step() * Math.min(.5 * c, .5),
          p = o.map(function (i) {
        var e = {
          id: i.id,
          data: i,
          points: [],
          areaPoints: []
        };
        return i.data.forEach(function (t, o) {
          var n = l.get(t.x),
              r = n.values.get(i.id),
              a = n.x,
              d = r.beforeHeight,
              c = r.height,
              s = d + c / 2,
              v = d,
              p = d + c;
          e.points.push({
            x: a,
            y: s,
            height: c,
            data: z({}, t)
          }), o > 0 && e.areaPoints.push({
            x: a - u,
            y0: v,
            y1: p
          }), e.areaPoints.push({
            x: a,
            y0: v,
            y1: p
          }), o < i.data.length - 1 && e.areaPoints.push({
            x: a + u,
            y0: v,
            y1: p
          });
        }), e;
      });
      return {
        series: p,
        xScale: s,
        heightScale: v
      };
    }({
      data: t,
      width: o,
      height: n,
      align: r,
      spacing: a,
      xPadding: d
    });
  }, [t, o, n, r, a, d]);
},
    V = function V(i) {
  return e(function () {
    return "function" == typeof i ? i : function () {
      return i;
    };
  }, [i]);
},
    Z = function Z(o) {
  var n = o.data,
      a = o.width,
      d = o.height,
      c = o.align,
      l = o.spacing,
      s = o.xPadding,
      v = o.interpolation,
      u = o.colors,
      p = o.fillOpacity,
      h = o.activeFillOpacity,
      f = o.inactiveFillOpacity,
      W = o.borderWidth,
      O = o.activeBorderWidth,
      P = o.inactiveBorderWidth,
      S = o.borderColor,
      L = o.borderOpacity,
      M = o.activeBorderOpacity,
      I = o.inactiveBorderOpacity,
      C = o.isInteractive,
      B = o.defaultActiveSerieIds,
      k = i(B),
      A = k[0],
      E = k[1],
      w = U({
    data: n,
    width: a,
    height: d,
    align: c,
    spacing: l,
    xPadding: s
  }),
      T = w.series,
      G = w.xScale,
      F = w.heightScale,
      H = function (i) {
    return e(function () {
      return m().x(function (i) {
        return i.x;
      }).y0(function (i) {
        return i.y0;
      }).y1(function (i) {
        return i.y1;
      }).curve("smooth" === i ? g : y);
    }, [i]);
  }(v),
      X = b(u, "id"),
      j = function (i) {
    var e = i.fillOpacity,
        o = i.activeFillOpacity,
        n = i.inactiveFillOpacity,
        a = i.borderWidth,
        d = i.activeBorderWidth,
        c = i.inactiveBorderWidth,
        l = i.borderColor,
        s = i.borderOpacity,
        v = i.activeBorderOpacity,
        u = i.inactiveBorderOpacity,
        p = i.isInteractive,
        h = i.activeSerieIds,
        f = V(e),
        g = V(o),
        y = V(n),
        m = V(a),
        b = V(d),
        W = V(c),
        O = r(),
        P = x(l, O),
        S = V(s),
        L = V(v),
        M = V(u),
        I = t(function (i) {
      return {
        fillOpacity: f(i),
        borderWidth: m(i),
        borderColor: P(i),
        borderOpacity: S(i)
      };
    }, [f, m, P, S]),
        C = t(function (i) {
      return {
        fillOpacity: g(i),
        borderWidth: b(i),
        borderColor: P(i),
        borderOpacity: L(i)
      };
    }, [g, b, P, L]),
        B = t(function (i) {
      return {
        fillOpacity: y(i),
        borderWidth: W(i),
        borderColor: P(i),
        borderOpacity: M(i)
      };
    }, [y, W, P, M]);
    return t(function (i) {
      return p && 0 !== h.length ? h.includes(i.id) ? C(i) : B(i) : I(i);
    }, [I, C, B, p, h]);
  }({
    fillOpacity: p,
    activeFillOpacity: h,
    inactiveFillOpacity: f,
    borderWidth: W,
    activeBorderWidth: O,
    inactiveBorderWidth: P,
    borderColor: S,
    borderOpacity: L,
    activeBorderOpacity: M,
    inactiveBorderOpacity: I,
    isInteractive: C,
    activeSerieIds: A
  });

  return {
    series: e(function () {
      return T.map(function (i) {
        var e = z({}, i, {
          color: X(i.data)
        });
        return z({}, e, j(e));
      });
    }, [T, X, j]),
    xScale: G,
    heightScale: F,
    areaGenerator: H,
    activeSerieIds: A,
    setActiveSerieIds: E
  };
},
    $ = function $(i) {
  var n = i.serie,
      r = i.isInteractive,
      a = i.onMouseEnter,
      d = i.onMouseMove,
      c = i.onMouseLeave,
      l = i.onClick,
      s = i.setActiveSerieIds,
      v = i.tooltip,
      u = W(),
      p = u.showTooltipFromEvent,
      h = u.hideTooltip,
      f = t(function (i) {
    p(o(v, {
      serie: n
    }), i), s([n.id]), a && a(n, i);
  }, [n, a, p, s, v]),
      g = t(function (i) {
    p(o(v, {
      serie: n
    }), i), d && d(n, i);
  }, [n, d, p, v]),
      y = t(function (i) {
    h(), s([]), c && c(n, i);
  }, [n, c, h, s]),
      m = t(function (i) {
    l && l(n, i);
  }, [n, l]);
  return e(function () {
    return {
      onMouseEnter: r ? f : void 0,
      onMouseMove: r ? g : void 0,
      onMouseLeave: r ? y : void 0,
      onClick: r ? m : void 0
    };
  }, [r, f, g, y, m]);
},
    _ = function _(i) {
  var t = i.series,
      o = i.position,
      n = i.padding,
      a = i.color,
      d = i.getLabel,
      c = r(),
      l = x(a, c);
  return e(function () {
    var i, e;
    return "start" === o ? (i = "end", e = -1 * n) : (i = "start", e = n), t.map(function (t) {
      var n = t.id;
      "function" == typeof d && (n = d(t.data));
      var r = "start" === o ? t.points[0] : t.points[t.points.length - 1];
      return {
        id: t.id,
        label: n,
        x: r.x + e,
        y: r.y,
        color: l(t),
        opacity: t.fillOpacity,
        serie: t,
        textAnchor: i
      };
    });
  }, [d, t, o, n, l]);
},
    ii = function ii(i) {
  var e = i.serie,
      t = i.areaGenerator,
      o = i.blendMode,
      n = i.isInteractive,
      r = i.onMouseEnter,
      c = i.onMouseMove,
      l = i.onMouseLeave,
      s = i.onClick,
      v = i.setActiveSerieIds,
      u = i.tooltip,
      p = $({
    serie: e,
    isInteractive: n,
    onMouseEnter: r,
    onMouseMove: c,
    onMouseLeave: l,
    onClick: s,
    setActiveSerieIds: v,
    tooltip: u
  }),
      h = a(),
      f = h.animate,
      g = h.config,
      y = d(t(e.areaPoints) || ""),
      m = k({
    color: e.color,
    fillOpacity: e.fillOpacity,
    stroke: e.borderColor,
    strokeOpacity: e.borderOpacity,
    config: g,
    immediate: !f
  });
  return I(A.path, {
    "data-testid": "area." + e.id,
    d: y,
    fill: e.fill ? e.fill : m.color,
    fillOpacity: m.fillOpacity,
    stroke: m.stroke,
    strokeWidth: e.borderWidth,
    strokeOpacity: m.strokeOpacity,
    style: {
      mixBlendMode: o
    },
    onMouseEnter: p.onMouseEnter,
    onMouseMove: p.onMouseMove,
    onMouseLeave: p.onMouseLeave,
    onClick: p.onClick
  });
},
    ei = function ei(i) {
  var e = i.getLabel,
      t = i.series,
      o = i.position,
      n = i.padding,
      d = i.color,
      c = r(),
      l = a(),
      s = l.animate,
      v = l.config,
      u = _({
    getLabel: e,
    series: t,
    position: o,
    padding: n,
    color: d
  }),
      p = w(u.length, u.map(function (i) {
    return {
      x: i.x,
      y: i.y,
      opacity: i.opacity,
      config: v,
      immediate: !s
    };
  }));

  return I(B, {
    children: p.map(function (i, e) {
      var t = u[e];
      return I(A.text, {
        "data-testid": "label." + o + "." + t.serie.id,
        x: i.x,
        y: i.y,
        textAnchor: t.textAnchor,
        dominantBaseline: "central",
        opacity: i.opacity,
        style: z({}, c.labels.text, {
          fill: t.color
        }),
        children: t.label
      }, t.id);
    })
  });
},
    ti = z({}, {
  align: "middle",
  layers: ["grid", "axes", "labels", "areas"],
  interpolation: "smooth",
  spacing: 0,
  xPadding: .6,
  colors: {
    scheme: "nivo"
  },
  blendMode: "normal",
  fillOpacity: .8,
  activeFillOpacity: 1,
  inactiveFillOpacity: .15,
  borderWidth: 1,
  activeBorderWidth: 1,
  inactiveBorderWidth: 0,
  borderColor: {
    from: "color",
    modifiers: [["darker", .4]]
  },
  borderOpacity: 1,
  activeBorderOpacity: 1,
  inactiveBorderOpacity: 0,
  startLabel: !1,
  startLabelPadding: 12,
  startLabelTextColor: {
    from: "color",
    modifiers: [["darker", 1]]
  },
  endLabel: !0,
  endLabelPadding: 12,
  endLabelTextColor: {
    from: "color",
    modifiers: [["darker", 1]]
  },
  enableGridX: !0,
  axisTop: {},
  axisBottom: {},
  isInteractive: !0,
  defaultActiveSerieIds: [],
  tooltip: function tooltip(i) {
    var e = i.serie;
    return I(O, {
      id: e.id,
      enableChip: !0,
      color: e.color
    });
  },
  role: "img"
}, {
  defs: [],
  fill: [],
  animate: !0,
  motionConfig: "gentle"
}),
    oi = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
    ni = function ni(i) {
  var t = i.data,
      r = i.align,
      a = void 0 === r ? ti.align : r,
      d = i.width,
      c = i.height,
      v = i.margin,
      f = i.layers,
      g = void 0 === f ? ti.layers : f,
      y = i.interpolation,
      m = void 0 === y ? ti.interpolation : y,
      b = i.spacing,
      x = void 0 === b ? ti.spacing : b,
      W = i.xPadding,
      O = void 0 === W ? ti.xPadding : W,
      P = i.colors,
      S = void 0 === P ? ti.colors : P,
      L = i.blendMode,
      M = void 0 === L ? ti.blendMode : L,
      B = i.fillOpacity,
      k = void 0 === B ? ti.fillOpacity : B,
      A = i.activeFillOpacity,
      E = void 0 === A ? ti.activeFillOpacity : A,
      w = i.inactiveFillOpacity,
      z = void 0 === w ? ti.inactiveFillOpacity : w,
      T = i.defs,
      G = void 0 === T ? ti.defs : T,
      F = i.fill,
      H = void 0 === F ? ti.fill : F,
      X = i.borderWidth,
      j = void 0 === X ? ti.borderWidth : X,
      Y = i.activeBorderWidth,
      K = void 0 === Y ? ti.activeBorderWidth : Y,
      R = i.inactiveBorderWidth,
      q = void 0 === R ? ti.inactiveBorderWidth : R,
      D = i.borderColor,
      J = void 0 === D ? ti.borderColor : D,
      N = i.borderOpacity,
      Q = void 0 === N ? ti.borderOpacity : N,
      U = i.activeBorderOpacity,
      V = void 0 === U ? ti.activeBorderOpacity : U,
      $ = i.inactiveBorderOpacity,
      _ = void 0 === $ ? ti.inactiveBorderOpacity : $,
      oi = i.startLabel,
      ni = void 0 === oi ? ti.startLabel : oi,
      ri = i.startLabelPadding,
      ai = void 0 === ri ? ti.startLabelPadding : ri,
      di = i.startLabelTextColor,
      ci = void 0 === di ? ti.startLabelTextColor : di,
      li = i.endLabel,
      si = void 0 === li ? ti.endLabel : li,
      vi = i.endLabelPadding,
      ui = void 0 === vi ? ti.endLabelPadding : vi,
      pi = i.endLabelTextColor,
      hi = void 0 === pi ? ti.endLabelTextColor : pi,
      fi = i.enableGridX,
      gi = void 0 === fi ? ti.enableGridX : fi,
      yi = i.axisTop,
      mi = void 0 === yi ? ti.axisTop : yi,
      bi = i.axisBottom,
      xi = void 0 === bi ? ti.axisBottom : bi,
      Wi = i.isInteractive,
      Oi = void 0 === Wi ? ti.isInteractive : Wi,
      Pi = i.defaultActiveSerieIds,
      Si = void 0 === Pi ? ti.defaultActiveSerieIds : Pi,
      Li = i.onMouseEnter,
      Mi = i.onMouseMove,
      Ii = i.onMouseLeave,
      Ci = i.onClick,
      Bi = i.tooltip,
      ki = void 0 === Bi ? ti.tooltip : Bi,
      Ai = i.role,
      Ei = void 0 === Ai ? ti.role : Ai,
      wi = l(d, c, v),
      zi = wi.margin,
      Ti = wi.innerWidth,
      Gi = wi.innerHeight,
      Fi = wi.outerWidth,
      Hi = wi.outerHeight,
      Xi = Z({
    data: t,
    width: Ti,
    height: Gi,
    align: a,
    spacing: x,
    xPadding: O,
    interpolation: m,
    colors: S,
    fillOpacity: k,
    activeFillOpacity: E,
    inactiveFillOpacity: z,
    borderWidth: j,
    activeBorderWidth: K,
    inactiveBorderWidth: q,
    borderColor: J,
    borderOpacity: Q,
    activeBorderOpacity: V,
    inactiveBorderOpacity: _,
    isInteractive: Oi,
    defaultActiveSerieIds: Si
  }),
      ji = Xi.series,
      Yi = Xi.xScale,
      Ki = Xi.heightScale,
      Ri = Xi.areaGenerator,
      qi = Xi.setActiveSerieIds,
      Di = e(function () {
    return u(G, ji, H, {
      targetKey: "fill"
    });
  }, [G, ji, H]),
      Ji = {
    grid: null,
    axes: null,
    labels: null,
    areas: null
  };

  g.includes("grid") && gi && (Ji.grid = I(p, {
    width: Ti,
    height: Gi,
    xScale: Yi
  }, "grid")), g.includes("axes") && (Ji.axes = I(h, {
    xScale: Yi,
    yScale: Ki,
    width: Ti,
    height: Gi,
    top: mi,
    bottom: xi
  }, "axes")), g.includes("areas") && (Ji.areas = I(n, {
    children: ji.map(function (i) {
      return I(ii, {
        areaGenerator: Ri,
        serie: i,
        blendMode: M,
        isInteractive: Oi,
        setActiveSerieIds: qi,
        onMouseEnter: Li,
        onMouseMove: Mi,
        onMouseLeave: Ii,
        onClick: Ci,
        tooltip: ki
      }, i.id);
    })
  }, "areas")), g.includes("labels") && (Ji.labels = C(n, {
    children: [!1 !== ni && I(ei, {
      getLabel: ni,
      series: ji,
      position: "start",
      padding: ai,
      color: ci
    }), !1 !== si && I(ei, {
      getLabel: si,
      series: ji,
      position: "end",
      padding: ui,
      color: hi
    })]
  }, "labels"));
  var Ni = e(function () {
    return {
      innerWidth: Ti,
      innerHeight: Gi,
      outerWidth: Fi,
      outerHeight: Hi,
      series: ji,
      xScale: Yi,
      areaGenerator: Ri
    };
  }, [Ti, Gi, Fi, Hi, ji, Yi, Ri]);
  return I(s, {
    defs: Di,
    width: Fi,
    height: Hi,
    margin: zi,
    role: Ei,
    children: g.map(function (i, e) {
      var t;
      return "function" == typeof i ? I(n, {
        children: o(i, Ni)
      }, e) : null != (t = null == Ji ? void 0 : Ji[i]) ? t : null;
    })
  });
},
    ri = function ri(i) {
  var e = i.isInteractive,
      t = void 0 === e ? ti.isInteractive : e,
      o = i.animate,
      n = void 0 === o ? ti.animate : o,
      r = i.motionConfig,
      a = void 0 === r ? ti.motionConfig : r,
      d = i.theme,
      l = i.renderWrapper,
      s = T(i, oi);
  return I(c, {
    animate: n,
    isInteractive: t,
    motionConfig: a,
    renderWrapper: l,
    theme: d,
    children: I(ni, z({
      isInteractive: t
    }, s))
  });
},
    ai = function ai(i) {
  return I(v, {
    children: function children(e) {
      var t = e.width,
          o = e.height;
      return I(ri, z({
        width: t,
        height: o
      }, i));
    }
  });
};

export { ri as AreaBump, N as Bump, ai as ResponsiveAreaBump, Q as ResponsiveBump, ti as areaBumpSvgDefaultProps, Y as bumpSvgDefaultProps, Z as useAreaBump, $ as useAreaBumpSerieHandlers, _ as useAreaBumpSeriesLabels, F as useBump, H as useBumpSerieHandlers, X as useBumpSeriesLabels };